import cs from 'classnames';
import type { FC } from 'react';
import { CheckCircleBold, CloseCircleBold } from 'solar-icons';
import { formatPrice } from '@/Module/Core/Helper';
import { useAppSelector } from '@/Module/Store/Hook';
import { MONTH_PERSIAN } from '@/Module/Subscription/Component/SubscriptionPageContainer/SubscriptionPageTabInner';
import { preparePersianTime } from '@/Module/Subscription/Help';
import type { ITransactionPlan } from '@/Module/Subscription/Model/DataModel';
import { transactionUserSelectById } from '@/Module/Subscription/Store/Selector';
const SubscriptionTransactionId: FC<Pick<ITransactionPlan, 'id'>> = ({
  id
}) => {
  const transaction = useAppSelector(state => transactionUserSelectById(state, id))!;
  const time = preparePersianTime({
    persianDate: transaction.persianCreatedDate
  });
  return <div className="flex w-full  flex-row  rounded-lg bg-grayOne p-4 " data-sentry-component="SubscriptionTransactionId" data-sentry-source-file="SubscriptionTransactionId.tsx">
      <div className="ml-4 flex  h-[48px] min-w-[48px] items-center justify-center rounded-full bg-white  text-blackThree">
        {transaction?.isSuccess ? <CheckCircleBold className="text-greenFour" /> : <CloseCircleBold className="text-redTwo" />}
      </div>
      <div className="flex w-full flex-col">
        <div className="font-semibold text-blackSeven ">
          اشتراک {MONTH_PERSIAN[transaction?.duration!]} {transaction?.subscriptionName?.split('_')[0]}{' '}
          <span>{transaction?.subscriptionType}</span>
        </div>
        <div className="my-2 text-blackThree ">
          <span>
            {time.day} {time.month} {time.year}
          </span>
          <span>، {time.clock} </span>
          <span>{time.wrap}</span>
        </div>
        <div className=" flex  flex-row justify-between">
          {transaction?.isSuccess ? <div className="text-greenFour">پرداخت موفق</div> : <div className="text-redTwo">پرداخت ناموفق</div>}
          <div className="text-sm text-blackFive">
            <span>مبلغ: </span>
            <span className={cs(` `)}>{transaction.amount ? formatPrice(transaction.amount) : 'رایگان'}</span>
          </div>
        </div>
        <div className="mt-4 flex justify-between rounded-md bg-white p-1 px-2 text-sm text-blackFive">
          <span>کد پیگیری تراکنش</span>
          <span>{transaction.subscriptionId}</span>
        </div>
      </div>
    </div>;
};
export default SubscriptionTransactionId;